export enum DocumentCategory {
  BUYBACK = 'buyback',
  CLASS_CONVERSION = 'class-conversion',
  FUNDRAISING_ROUND = 'fundraising-round',
  GRANT = 'grant',
  OTHER = 'other',
  PLANS = 'plans',
  POOLS = 'pools',
  SAFE = 'safe',
  SECONDARIES = 'secondaries',
  SHARE_CLASSES = 'share-classes',
  SHARE_ISSUANCE = 'share-issuance',
  VALUATION_EVENT = 'valuation-event',
}

export enum DocumentSubCategory {
  BUYBACK_BOARD_RESOLUTION = 'buyback-board-resolution',
  BUYBACK_SHARE_REPURCHASE_AGREEMENT = 'buyback-share-repurchase-agreement',
  CLASS_CONVERSION_BOARD_RESOLUTION = 'class-conversion-board-resolution',
  FUNDRAISING_ROUND_SHAREHOLDER_AGREEMENT = 'fundraising-round-shareholder-agreement',
  FUNDRAISING_ROUND_SUBSCRIPTION_AGREEMENT = 'fundraising-round-subscription-agreement',
  GRANT_AGREEMENT = 'grant-agreement',
  GRANT_EXERCISE_NOTICE = 'grant-exercise-notice',
  GRANT_HURDLE_APPROVAL = 'grant-hurdle-approval',
  GRANT_PHANTOM_PAYOUT = 'grant-phantom-payout',
  OTHER_OTHER = 'other-other',
  PLANS_BOARD_RESOLUTION = 'plans-board-resolution',
  PLANS_PLAN_AGREEMENT = 'plans-plan-agreement',
  POOLS_BOARD_RESOLUTION = 'pools-board-resolution',
  SAFE_SAFE_AGREEMENT = 'safe-safe-agreement',
  SAFE_SAFE_CONVERSION_NOTICE = 'safe-safe-conversion-notice',
  SECONDARIES_BOARD_RESOLUTION = 'secondaries-board-resolution',
  SECONDARIES_PURCHASE_AND_SELL_AGREEMENT = 'secondaries-purchase-and-sell-agreement',
  SHARE_CLASSES_BOARD_RESOLUTION = 'share-classes-board-resolution',
  SHARE_ISSUANCE_BOARD_RESOLUTION = 'share-issuance-board-resolution',
  SHARE_ISSUANCE_SHARE_CERTIFICATE = 'share-issuance-share-certificate',
  VALUATION_EVENT_BOARD_RESOLUTION = 'valuation-event-board-resolution',
}

export enum DocumentLinkedEventKind {
  BUYBACK_EVENT_GENERAL = 'buyback-event-general',
  BUYBACK_TRANSACTION_INDIVIDUAL = 'buyback-transaction-individual',
  CLASS_CONVERSION_EVENT_GENERAL = 'class-conversion-event-general',
  EXERCISE_TRANSACTION = 'exercise-transaction',
  GRANT_TRANSACTION = 'grant-transaction',
  HURDLE_APPROVAL_TRANSACTION = 'hurdle-approval-transaction',
  INVESTMENT_TRANSACTION = 'investment-transaction',
  NONE = 'none',
  PHANTOM_PAYOUT_TRANSACTION = 'phantom-payout-transaction',
  PLAN_RECORD = 'plan-record',
  POOL_RECORD = 'pool-record',
  SAFE_CONVERSION_RECORD = 'safe-conversion-record',
  SAFE_RECORD = 'safe-record',
  SECONDARIES_EVENT_GENERAL = 'secondaries-event-general',
  SECONDARIES_TRANSACTION_INDIVIDUAL = 'secondaries-transaction-individual',
  SHARE_CLASS_RECORD = 'share-class-record',
  SHARE_ISSUANCE_EVENT_GENERAL = 'share-issuance-event-general',
  SHARE_ISSUANCE_TRANSACTION_INDIVIDUAL = 'share-issuance-transaction-individual',
  VALUATION_EVENT = 'valuation-event',
}
